export enum FiltersActions {
  SetFilter = 'SET_FILTER',
  ClearFilters = 'CLEAR_FILTERS',
}
